import { render, staticRenderFns } from "./uploadDocumentsHKTVM.vue?vue&type=template&id=a1675854&"
import script from "./uploadDocumentsHKTVM.vue?vue&type=script&lang=js&"
export * from "./uploadDocumentsHKTVM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports